export default __webpack_public_path__ + "static/media/02.68b56a79.jpg";